<template>
    <div class="bgContent">
        <div class="cont" :style="{background:bg}">
            <!--<div class="topicon" v-if="bg">
                <Icon @click="closeFn" type="md-close" class="close"/>
                <Icon @click="backFn" type="ios-arrow-back" size="20" class="back"/>
            </div>-->
            <keep-alive>
                <router-view ref="scroll" class="mainBox" v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view ref="scroll" class="mainBox" v-if="!$route.meta.keepAlive"></router-view>
        </div>

    </div>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: "about",
        data() {
            return {
                imgUrl:null,
                timer:null,//定时器,
                bg:'',
                teamListOptions:[],//梯队列表
                teamNameFlag:false,//是否触发梯队名称--ai动画执行顺序
            }
        },
        computed: {
            paramsCommandFn() {
                return this.$store.state.paramsCommand;
            },
            teamNameFn() {
                return this.$store.state.teamName;
            }
        },
        beforeRouteLeave(to, from, next) {
            if (to.name == "assessmentReport") {
                to.meta.keepAlive = true;
            } else {
                to.meta.keepAlive = false;
            }
            to.meta.keepAlive=false
            next();
        },
        watch: {
            paramsCommandFn: {
                handler(val, old) {
                    let command = this.$aiJson.command;//模块命令比如 训练报告
                    let flag = 0;//是否触功能指令 训练报告
                    // for (let team=0;team<this.teamListOptions.length;team++){//判断指令内是否有梯队名称
                    //     if (eval('/' + this.teamListOptions[team].label + '/gi').test(val) || eval('/u时期/gi').test(val) || eval('/优17/gi').test(val) || eval('/优时期/gi').test(val)) {
                    //         //给 vuex teamid赋值
                    //         if(eval('/u时期/gi').test(val) || eval('/优17/gi').test(val) || eval('/优时期/gi').test(val)){
                    //             this.$store.state.teamName='U17_'+new Date().getTime();
                    //             for (let u17=0;u17<this.teamListOptions.length;u17++){
                    //                 if(this.teamListOptions[u17].label=='U17'){
                    //                     this.$store.state.teamId=this.teamListOptions[u17].value;
                    //                 }
                    //             }
                    //         }else {
                    //             this.$store.state.teamName=this.teamListOptions[team].label+'_'+new Date().getTime()
                    //             this.$store.state.teamId=this.teamListOptions[team].value;
                    //         }
                    //         console.log(this.$store.state.teamName)
                    //         for (let p = 0; p < command.length; p++) {
                    //             for (let g = 0; g < command[p].identifyWord.length; g++) {//判断模块指令是否存在
                    //                 if (eval('/' + command[p].identifyWord[g] + '/gi').test(val)) {
                    //
                    //                     if(this.$store.state.router.name!=command[p].name){
                    //                         this.$store.dispatch("setFlag", '1_' + new Date().getTime());//vuex改变识别信息---好的
                    //                         clearInterval(this.$parent.timer);
                    //                         this.$parent.imgAi(this.$imgJson.taskAiImgArr);
                    //                         this.$store.dispatch("setRouter", {path:command[p].url,name:command[p].name,goType:1,params:this.$route.params});//vuex改变路由
                    //                         this.$store.state.speakStr=command[p].speak;
                    //                         this.teamNameFlag=false;
                    //                     }
                    //                     flag = 1;
                    //                     return;
                    //                 }else {
                    //                     flag = 0;
                    //                 }
                    //             }
                    //         }
                    //         if(!flag){
                    //             console.log(this.$route.name)
                    //             if(eval('/.*Detail.*/gi').test(this.$route.name)){
                    //                 this.$store.dispatch("setFlag", '1_' + new Date().getTime());//vuex改变识别信息
                    //                 this.$store.dispatch("setRouter", {path:null,name:null,goType:-1,params:this.$route.params});//vuex改变路由
                    //             }
                    //         }
                    //         if(this.$route.name!='main_btn'){
                    //             flag = 1;
                    //             return
                    //         }
                    //     }else {
                    //         flag = 0;
                    //     }
                    // }

                    if(!flag){
                        for (let p = 0; p < command.length; p++) {
                            for (let g = 0; g < command[p].identifyWord.length; g++) {//判断模块指令是否存在
                                if (eval('/' + command[p].identifyWord[g] + '/gi').test(val)) {
                                    if(!this.$store.state.teamId){
                                        this.$store.state.teamName=this.teamListOptions[0].label+'_'+new Date().getTime()
                                        this.$store.state.teamId=this.teamListOptions[0].value;
                                    }else {
                                        this.$store.state.teamName=this.$store.state.teamName.split('_')[0]+'_'+new Date().getTime()
                                    }
                                    if(this.$store.state.router.name!=command[p].name){
                                        this.$store.dispatch("setFlag", '1_' + new Date().getTime());//vuex改变识别信息---好的
                                        clearInterval(this.$parent.timer);
                                        this.$parent.imgAi(this.$imgJson.taskAiImgArr);
                                        this.$store.dispatch("setRouter", {path:command[p].url,name:command[p].name,goType:1,params:this.$route.params});//vuex改变路由
                                        this.$store.state.speakStr=command[p].speak;
                                        this.teamNameFlag=false;
                                    }
                                    flag = 1;
                                    return;
                                }else {
                                    flag = 0;
                                }
                            }
                        }
                    }

                    if(!flag){
                        if(
                            ((!eval('/.*introduce.*/gi').test(this.$route.name)) &&
                                (!eval('/.*lessonPlan.*/gi').test(this.$route.name)) &&
                                (!eval('/.*lessonDetail.*/gi').test(this.$route.name)) &&
                                (!eval('/.*coachAssessment.*/gi').test(this.$route.name)) &&
                                (!eval('/.*videoList.*/gi').test(this.$route.name)) &&
                                (!eval('/.*videoClipList.*/gi').test(this.$route.name)) &&
                                (!eval('/.*assessmentReport.*/gi').test(this.$route.name)) &&
                                (!eval('/.*AC_report.*/gi').test(this.$route.name)) &&
                                (!eval('/.*coachList.*/gi').test(this.$route.name)) &&
                                (!eval('/.*injuryReport.*/gi').test(this.$route.name)) &&
                                (!eval('/.*playersReport.*/gi').test(this.$route.name)) &&
                                (!eval('/.*intensityReport.*/gi').test(this.$route.name)) &&
                                (!eval('/.*AC_AIM.*/gi').test(this.$route.name)) &&
                                (!eval('/.*bodyBtn.*/gi').test(this.$route.name))) ||
                            eval('/.*Detail.*/gi').test(this.$route.name)){
                            this.$store.dispatch("setFlag", '0_' + new Date().getTime());//vuex改变识别信息
                        }
                        this.$store.dispatch("setLookDetail", val);//vuex改变识别信息
                    }
                },
                deep: true
            },
            $route(val, old) {
                if(this.$store.state.backFlag){
                    this.$store.state.speakStr=val.meta.speakStr
                    this.$store.state.backFlag=false;
                }
                this.$children[0].time?clearInterval(this.$children[0].time):''
                if((!this.teamNameFlag) &&
                    (val.name!='main_btn' &&
                        val.name!='Home' &&
                        val.name!='bodyBtn' &&
                        val.name!='introduce' &&
                        val.name!='smartPitch' &&
                        val.name!='smartPitchCamera' &&
                        val.name!='moment' &&
                        val.name!='videoClipList'  &&
                        val.name!='lessonPlan' &&
                        val.name!='lessonDetail')){
                    this.$parent.audioPlayFn(this.$global.audioPlayUrl("<speak>这是" + '<say-as interpret-as="cardinal">'+this.$store.state.teamName.split('_')[0]+'</say-as>' +this.$store.state.speakStr +'</speak>'), true,false)
                    this.$parent.imgAi(this.$imgJson.handAiImgArr);
                    this.teamNameFlag=true;
                }else {
                    this.teamNameFlag=false
                }


                // console.log(val)
                // console.log(old)
                // this.$store.state.pageParams = val.params;
                // console.log(this.$store.state.pageParams)
                if(!(val.name == 'lessonPlan' && old.name == 'lessonDetail') && !(val.name == 'videoList' && old.name == 'videoClipList')) {
                    this.$store.state.pageParams = {
                        id: null,
                        page: null,
                        tagsCheck: null
                    }
                }
            },
            teamNameFn: {
                handler(val, old) {
                    if(this.teamNameFlag){
                        clearInterval(this.$parent.timer);
                        this.$parent.imgAi(this.$imgJson.handAiImgArr);
                    }
                    if ((this.$store.state.speakStr == '这是俱乐部的训练教案' && this.$route.name != 'lessonPlan') || this.$store.state.speakStr == '这是俱乐部介绍' && this.$route.name != 'introduce') {
                        // clearInterval(this.$parent.timer);
                        // this.$parent.imgAi(this.$imgJson.handAiImgArr);
                        // this.$parent.audioPlayFn(this.$global.audioPlayUrl(this.$store.state.speakStr), true,false)
                    }else {
                        if(this.teamNameFlag){
                            this.$parent.audioPlayFn(this.$global.audioPlayUrl("<speak>这是" + '<say-as interpret-as="cardinal">'+val.split('_')[0]+'</say-as>' +this.$store.state.speakStr +'</speak>'), true,false)
                        }
                    }

                },
                deep: true
            },

        },
        mounted() {
            this.info();
        },
        methods: {
            //获取梯队列表
            info() {
                this.$server.getTeamList({id:this.$store.state.userId}).then((res) => {
                    this.teamListOptions = [];
                    for (let i = 0; i < res.data.length; i++) {
                        this.teamListOptions.push({
                            value: res.data[i].id,
                            label: res.data[i].name
                        })
                    }
                })
            },
            //关闭页面开启动画 关闭ai语音
            closeFn() {
                console.log('关闭语音')
                this.$parent.closeAi();
                this.$router.push({
                    path: '/',
                    name: 'Home'
                });
            },
            backFn() {
                this.$router.back(-1);
            },
        },
        beforeDestroy() {
            this.$store.state.teamName=null
            this.$store.state.teamId=null
        }
    }
</script>
<style scoped lang="less">
    .cont {
        width: 100%;
        height: 100%;
        /*margin-top: 60px;*/
        min-height: 300px;
        overflow: hidden;
        /*background: #01010170;*/
        padding-bottom: 20px;
        position: relative;
    }
    .topicon{
        width: 100%;
        height: 45px;
        /*background: #01010170;*/
        border-bottom: 1px solid rgba(92,93,98,0.55);
    }
    .mainBox{
        width: 100%;
        height: calc(100% - 45px);
        /*overflow-y: scroll;*/
    }
</style>
